import Widget from "lib/ui/Widget";
import { observe } from "../../../lib/reactive";
/**
 * This class encapsulates common functionality for widgets that are an editor for a value.
 */
export default class AbstractEditWidget extends Widget {
    constructor(container = null) {
        super(container);
        this.v = observe({ committed: false, value: null });
    }
    setValue(v) {
        this.commit(v);
        this.render();
        return this;
    }
    get() {
        return this.v.value().value;
    }
    render() {
    }
    commit(value, render = false) {
        this.v.set({ value: value, committed: true });
        if (render)
            this.render();
    }
    preview(value) {
        this.v.set({ value: value, committed: false });
        return this;
    }
    onChange(handler) {
        this.v.subscribe(handler);
        return this;
    }
    onPreview(handler) {
        this.v.subscribe((v) => { if (!v.committed)
            handler(v.value); });
        return this;
    }
    onCommit(handler) {
        this.v.subscribe((v) => { if (v.committed && v.value != null)
            handler(v.value); });
        return this;
    }
}
